export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6268.a8aa43f1.jpg";